export default {"src":"https://webcdn.trailways.com/_next/static/media/close-dark.08a5d7de.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};